/**
 * SHA-256 of the lowercased input, as a lowercase hex string. Used for the
 * GTM `email_hashed` parameter (the tagging plan requires lowercasing the
 * email before hashing).
 */
export const sha256LowercaseHex = async (input: string): Promise<string> => {
  const data = new TextEncoder().encode(input.toLowerCase());
  const digest = await crypto.subtle.digest('SHA-256', data);

  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};
